<template>
  <div>
    <BaseFetchData :action="fetchApprovalClaims" :lazy="loadOnMounted === false">
      <ApprovalClaimList
        :project-asset="projectAsset"
        :approval-claims="approvalClaims"
        :load-list="fetchApprovalClaims"
        @approval-claim-list-changed="$emit('approval-claim-manager-changed')"
      />
    </BaseFetchData>
  </div>
</template>

<script>
import { projectAssetApprovalClaimsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import ApprovalClaimList from './ApprovalClaimManager/ApprovalClaimList.vue';

export default {
  components: { ApprovalClaimList },
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      approvalClaims: [],
    };
  },
  computed: {
    loadOnMounted() {
      if (typeof this.projectAsset?.approvalClaims !== 'number') {
        return true;
      }

      return this.projectAsset.approvalClaimsCount > 0;
    },
  },
  methods: {
    async fetchApprovalClaims() {
      try {
        const response = await projectAssetApprovalClaimsClient.list(this.projectAsset.id, {
          include: ['reviewer', 'requester'],
        });

        this.approvalClaims = mapKeysToCamelCase(response.data, true);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
